import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { useTheme } from "../../context/ThemeContext";
import Image from "../image";

import includedImgTick from "images/ingoTick.svg";
import includedFlexLightImgTick from "images/tickFlex.svg";
import GVILightTick from "images/gviLightLogo.svg";

const CollapsibleListINGOWrapper = ({
  listItems,
  showMore = false,
  collapseBtnTitle = "less",
  expandBtnTitle = "more",
  btnStyle = "text-generic-text planet:text-green-standard text-xs font-body font-normal",
  containerClass = "flex py-3 items-center",
  listContainerClass = "flex flex-row flex-wrap gap-2",
  listItemClass = "flex flex-row gap-2 items-center",
  listTextClass = "text-xs font-body text-gray-generic self-center",
  displayPlain = false,
  displayPlainCharCount = 50,
  breakpoint = "xs",
  gviFlex,
  itemTextClass = "text-gray-generic"
}) => {
  const { colorMode } = useTheme();
  const initialVisibleItems = breakpoint === "xs" ? 10 : listItems?.length;
  const [showLimit, setShowLimit] = useState(parseInt(initialVisibleItems));
  const [readMore, setReadMore] = useState(false);
  const linkName = readMore ? collapseBtnTitle : expandBtnTitle;

  let mobileList = listItems
    ?.slice(0, showLimit)
    ?.flatMap((it) => it?.name)
    ?.join(", ")
    ?.slice(0, displayPlainCharCount);

  if (mobileList?.length >= displayPlainCharCount) {
    mobileList = mobileList?.concat(
      "...",
      "<span class='" + btnStyle + "'> + more </span>"
    );
  }

  useEffect(() => {
    setShowLimit(breakpoint === "xs" ? listItems?.length : listItems?.length);
  }, [breakpoint, listItems?.length]);

  const GVIFlexLogo = colorMode === "light" ? GVILightTick : includedImgTick;
  const GVILogo = colorMode === "light" ? GVILightTick : includedImgTick;
  const tickIcon = gviFlex ? GVIFlexLogo : GVILogo;

  return (
    <div className={containerClass}>
      <Image
        imageClass="w-[10px] sm:w-2 mr-2 mt-1 flex-shrink-0 hidden"
        sourceUrl={tickIcon}
        image=""
        imageAlt=""
      />
      <div className={listContainerClass}>
        {displayPlain ? (
          <div
            className={listTextClass}
            dangerouslySetInnerHTML={{ __html: mobileList }}
          ></div>
        ) : (
          <>
            {listItems?.slice(0, showLimit)?.map((listItem, idx) => (
              <div className={listItemClass} key={idx}>
                <Image
                  imageClass="w-2.5 sm:flex"
                  sourceUrl={tickIcon}
                  image=""
                  imageAlt=""
                />

                <div
                  className={`text-xs font-body self-center planet:text-gray-generic ${itemTextClass}`}
                  dangerouslySetInnerHTML={{
                    __html: listItem?.name
                  }}
                />
              </div>
            ))}

            {listItems?.length > initialVisibleItems && showMore ? (
              <button
                className={btnStyle}
                onClick={() => {
                  setReadMore(!readMore);
                  setShowLimit(
                    readMore ? initialVisibleItems : listItems?.length
                  );
                }}
              >
                + {linkName}
              </button>
            ) : (
              listItems?.length > initialVisibleItems && (
                <>
                  {showMore && (
                    <div className={btnStyle}>&nbsp;+ {linkName}</div>
                  )}
                </>
              )
            )}
          </>
        )}
      </div>
    </div>
  );
};

CollapsibleListINGOWrapper.propTypes = {
  visibleItems: PropTypes.number,
  listItems: PropTypes.array,
  listStyle: PropTypes.string,
  listItemStyle: PropTypes.string,
  btnStyle: PropTypes.string,
  wrapperContainerStyle: PropTypes.string
};

export default CollapsibleListINGOWrapper;
